var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3071 25C6.70713 25 1.30713 19.6 1.30713 13C1.30713 6.4 6.70713 1 13.3071 1C19.9071 1 25.3071 6.4 25.3071 13C25.3071 19.6 19.9071 25 13.3071 25Z",
    fill: "#192643",
    stroke: "#00B0A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59222 7.54148L15.582 22.2246L17.3969 16.0881L22.9507 12.9091L6.59222 7.54148ZM9.5361 9.35501L20.9895 13.1092L17.0772 15.3201L9.5361 9.35501ZM9.03484 9.98872L16.5759 15.9538L15.2935 20.245L9.03484 9.98872Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon);
export default __webpack_public_path__ + "static/media/nav_icon.49eb411595096ecc2ce6a6e67d157d41.svg";
export { ForwardRef as ReactComponent };